export default {
  'RowContainer.Row.InspectionItems.NameWrapper': ({ isOpen }, _, internalStateSetter) => {
    internalStateSetter({ isOpen: !isOpen });
  },
  'RowContainer.Row.Photos.PhotosWrapper.DownloadImages': ({ }, outlet) => {
    outlet({ action: 'download' })
  },
  'RowContainer.Row.Photos.PhotosWrapper.ViewImages': ({ }, outlet) => {
    outlet({ action: 'view' })
  }
}